
import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PolicyHero from './components/PolicyHero';
import ShippingInfo from './components/ShippingInfo';
import ReturnsPolicy from './components/ReturnsPolicy';
import RefundTable from './components/RefundTable';
import PolicyCta from './components/PolicyCta';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

const sections = [
  { id: 'shipping', label: 'Shipping', icon: 'ri-truck-line' },
  { id: 'returns', label: 'Returns', icon: 'ri-exchange-line' },
  { id: 'refunds', label: 'Refunds', icon: 'ri-refund-2-line' },
];

export default function ShippingReturnsPage() {
  const [activeSection, setActiveSection] = useState('shipping');

  useSEO({
    title: 'Shipping & Returns Policy | Daliah Secret Luxury Perfumes & Hair Oils',
    description: 'Learn about Daliah Secret shipping options, 30-day return policy, and hassle-free refund process. Free shipping on orders over $100. International delivery to 50+ countries for luxury perfumes and hair oils.',
    keywords: 'Daliah Secret shipping, returns policy, refund process, free shipping perfumes, international delivery hair oils',
    canonical: '/shipping-returns',
    ogType: 'website',
    schema: generateWebPageSchema(
      'Shipping & Returns Policy',
      'Daliah Secret shipping options, return policy, and refund information for luxury perfumes and hair oils.',
      '/shipping-returns'
    ),
  });

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map((s) => ({
        id: s.id,
        el: document.getElementById(s.id),
      }));

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const el = sectionElements[i].el;
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 200) {
            setActiveSection(sectionElements[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <PolicyHero />

      {/* Sticky Section Nav */}
      <div className="sticky top-[72px] z-40 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-1">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`flex items-center gap-2 px-5 py-4 text-sm font-medium transition-all cursor-pointer whitespace-nowrap border-b-2 ${
                  activeSection === section.id
                    ? 'border-[#2E7D32] text-[#2E7D32]'
                    : 'border-transparent text-gray-500 hover:text-gray-800'
                }`}
              >
                <i className={`${section.icon} text-base`}></i>
                {section.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <ShippingInfo />
      <ReturnsPolicy />
      <RefundTable />
      <PolicyCta />
      <Footer />
    </div>
  );
}
